"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M9.062 1.884h1V.951A.953.953 0 0 0 9.11 0H6.888a.953.953 0 0 0-.951.951v.933h1L6.887 1 9.063.951v.933ZM4.666 16h6.665a1.856 1.856 0 0 0 1.854-1.854v-9.4h-1v9.4a.854.854 0 0 1-.854.854H4.666a.855.855 0 0 1-.854-.854v-9.4h-1v9.4c0 1.022.832 1.854 1.854 1.854Zm.392-2.858h1V4.746h-1v8.396Zm3.44 0h-1V4.746h1v8.396Zm1.442 0h1V4.746h-1v8.396Zm4.308-9.782H1.75v-1h12.498v1Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M13.8 2.828h1.125V1.34c0-.686-.559-1.245-1.245-1.245h-3.36c-.686 0-1.245.559-1.245 1.245v1.488H10.2V1.34a.12.12 0 0 1 .12-.12h3.36a.12.12 0 0 1 .12.12v1.488ZM6.961 23.905H17.04a2.614 2.614 0 0 0 2.61-2.61V7.078h-1.125v14.217c0 .818-.666 1.485-1.485 1.485H6.96c-.82 0-1.486-.667-1.486-1.485V7.078H4.35v14.217a2.614 2.614 0 0 0 2.611 2.61Zm.785-4.129h1.125V7.078H7.746v12.698Zm4.816 0h-1.124V7.078h1.124v12.698Zm2.567 0h1.125V7.078h-1.125v12.698ZM21.45 4.604H2.55V3.48h18.9v1.125Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M18.4 3.771h1.5V1.787c0-.915-.745-1.66-1.66-1.66h-4.48c-.915 0-1.66.745-1.66 1.66v1.984h1.5V1.787a.16.16 0 0 1 .16-.16h4.48a.16.16 0 0 1 .16.16v1.984ZM9.281 31.873H22.72a3.484 3.484 0 0 0 3.48-3.48V9.437h-1.5v18.956c0 1.091-.888 1.98-1.98 1.98H9.281a1.983 1.983 0 0 1-1.98-1.98V9.437H5.8v18.956a3.485 3.485 0 0 0 3.48 3.48Zm1.047-5.505h1.5V9.437h-1.5v16.931Zm6.422 0h-1.5V9.437h1.5v16.931Zm3.422 0h1.5V9.437h-1.5v16.931ZM28.6 6.139H3.4v-1.5h25.2v1.5Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M27.844 6.04h1.875V2.427a2.322 2.322 0 0 0-2.32-2.32H20.6a2.322 2.322 0 0 0-2.319 2.32V6.04h1.875V2.427c0-.245.2-.444.444-.444h6.8c.244 0 .444.199.444.444V6.04ZM13.8 47.892h20.4a5.088 5.088 0 0 0 5.082-5.082V14.04h-1.875v28.77a3.21 3.21 0 0 1-3.207 3.207H13.8a3.211 3.211 0 0 1-3.208-3.207V14.04H8.718v28.77a5.088 5.088 0 0 0 5.083 5.082Zm1.79-8.155h1.876V14.04h-1.875v25.698Zm9.347 0h-1.875V14.04h1.875v25.698Zm5.595 0h1.875V14.04h-1.875v25.698ZM43.125 8.831H4.875V6.956h38.25V8.83Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M37.125 8.054h2.5V3.236A3.095 3.095 0 0 0 36.533.144h-9.066a3.095 3.095 0 0 0-3.092 3.092v4.818h2.5V3.236c0-.327.265-.592.592-.592h9.066c.326 0 .592.265.592.592v4.818ZM18.401 63.856h27.197a6.784 6.784 0 0 0 6.776-6.777V18.72h-2.5v38.36a4.28 4.28 0 0 1-4.276 4.277H18.401a4.282 4.282 0 0 1-4.277-4.277V18.72h-2.5v38.36a6.784 6.784 0 0 0 6.777 6.777Zm2.388-10.873h2.5V18.719h-2.5v34.264Zm12.461 0h-2.5V18.719h2.5v34.264Zm7.461 0h2.5V18.719h-2.5v34.264ZM57.5 11.774h-51v-2.5h51v2.5Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconTrash = function IconTrash(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Trash' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Trash"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconTrash.sizes = [16, 24, 32, 48, 64];
IconTrash.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconTrash;
exports.default = _default;